// extracted by mini-css-extract-plugin
export var cookies = "style-module--cookies--UyCkP";
export var cookiesAnimated = "style-module--cookiesAnimated--HVISN";
export var description = "style-module--description--9rqUc";